import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DashboardItem } from '../interfaces/dashboard-item.interface';
import { DashboardContext } from '../interfaces/dashboard-context.interface';

@Injectable({
	providedIn: 'root',
})
export class DashboardItemService {
	readonly url: string = 'dashboard';
	constructor(private http: HttpClient) {}

	public get(): Observable<DashboardItem[]> {
		return this.http.get<DashboardItem[]>(this.url + '/getAll');
	}

	public getById(companyId: number): Observable<DashboardItem[]> {
		return this.http.get<DashboardItem[]>(this.url + '/getAllById/' + companyId);
	}

	public adminGetAll(): Observable<DashboardItem[]> {
		return this.http.get<DashboardItem[]>(this.url + '/getAllAdmin')
	}

	public getContext(): Observable<DashboardContext> {
		return this.http.get<DashboardContext>(this.url + '/getContext/');
	}
}
